// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verification-center {
  display: grid;
  gap: 1.25rem;
  width: 100%;
}

.verification-center--card {
  padding: 1rem;
  border: 1px solid #d7e0da;
  border-radius: 8px;
  background: #fff;
}

.verification-status-banner {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 1rem;
  border: 1px solid #d7e0da;
  border-radius: 8px;
  background: #f7faf8;
}

.verification-status-banner > i {
  margin-top: 0.15rem;
  font-size: 1.35rem;
}

.verification-status-banner strong,
.verification-status-banner p {
  display: block;
  margin: 0;
}

.verification-status-banner p {
  margin-top: 0.25rem;
}

.verification-status-banner.is-verified {
  color: #14532d;
  border-color: #86efac;
  background: #f0fdf4;
}

.verification-status-banner.is-pending {
  color: #78350f;
  border-color: #fcd34d;
  background: #fffbeb;
}

.verification-status-banner.is-rejected {
  color: #7f1d1d;
  border-color: #fca5a5;
  background: #fef2f2;
}

.verification-payout-alternative {
  padding: 1rem;
  border-left: 4px solid #3b82f6;
  background: #eff6ff;
}

.verification-payout-alternative p {
  margin: 0.35rem 0;
}

.verification-records h3,
.verified-seller-form h3 {
  margin: 0 0 0.75rem;
}

.verification-records ul {
  display: grid;
  gap: 0.65rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.verification-record {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem;
  border: 1px solid #d7e0da;
  border-radius: 6px;
}

.verification-record > div {
  display: grid;
  gap: 0.2rem;
}

.verification-record__status {
  text-align: right;
}

.verified-seller-form {
  display: grid;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #d7e0da;
}

.verified-seller-form__heading p {
  margin: 0;
}

.verification-field {
  display: grid;
  gap: 0.35rem;
}

.verification-field label {
  font-weight: 600;
}

.verification-field input[type='text'],
.verification-field input[type='file'] {
  box-sizing: border-box;
  width: 100%;
}

.verification-image-preview {
  display: block;
  width: min(100%, 260px);
  max-height: 180px;
  margin-top: 0.5rem;
  border-radius: 6px;
  object-fit: cover;
}

.verification-retention-notice {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  margin: 0;
  padding: 0.75rem;
  border-radius: 6px;
  background: #f3f4f6;
  font-size: 0.9rem;
}

.verification-inline-error {
  padding: 0.75rem;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  color: #7f1d1d;
  background: #fef2f2;
}

@media (max-width: 600px) {
  .verification-record {
    display: grid;
  }

  .verification-record__status {
    text-align: left;
  }
}

[data-theme='dark'] .verification-center--card,
[data-theme='dark'] .verification-record {
  border-color: #3a4a40;
  background: #1c2620;
}

[data-theme='dark'] .verification-retention-notice {
  background: #222f28;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Verification/VerificationCenter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".verification-center {\n  display: grid;\n  gap: 1.25rem;\n  width: 100%;\n}\n\n.verification-center--card {\n  padding: 1rem;\n  border: 1px solid #d7e0da;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.verification-status-banner {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  padding: 1rem;\n  border: 1px solid #d7e0da;\n  border-radius: 8px;\n  background: #f7faf8;\n}\n\n.verification-status-banner > i {\n  margin-top: 0.15rem;\n  font-size: 1.35rem;\n}\n\n.verification-status-banner strong,\n.verification-status-banner p {\n  display: block;\n  margin: 0;\n}\n\n.verification-status-banner p {\n  margin-top: 0.25rem;\n}\n\n.verification-status-banner.is-verified {\n  color: #14532d;\n  border-color: #86efac;\n  background: #f0fdf4;\n}\n\n.verification-status-banner.is-pending {\n  color: #78350f;\n  border-color: #fcd34d;\n  background: #fffbeb;\n}\n\n.verification-status-banner.is-rejected {\n  color: #7f1d1d;\n  border-color: #fca5a5;\n  background: #fef2f2;\n}\n\n.verification-payout-alternative {\n  padding: 1rem;\n  border-left: 4px solid #3b82f6;\n  background: #eff6ff;\n}\n\n.verification-payout-alternative p {\n  margin: 0.35rem 0;\n}\n\n.verification-records h3,\n.verified-seller-form h3 {\n  margin: 0 0 0.75rem;\n}\n\n.verification-records ul {\n  display: grid;\n  gap: 0.65rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.verification-record {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem;\n  border: 1px solid #d7e0da;\n  border-radius: 6px;\n}\n\n.verification-record > div {\n  display: grid;\n  gap: 0.2rem;\n}\n\n.verification-record__status {\n  text-align: right;\n}\n\n.verified-seller-form {\n  display: grid;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #d7e0da;\n}\n\n.verified-seller-form__heading p {\n  margin: 0;\n}\n\n.verification-field {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.verification-field label {\n  font-weight: 600;\n}\n\n.verification-field input[type='text'],\n.verification-field input[type='file'] {\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.verification-image-preview {\n  display: block;\n  width: min(100%, 260px);\n  max-height: 180px;\n  margin-top: 0.5rem;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n.verification-retention-notice {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  margin: 0;\n  padding: 0.75rem;\n  border-radius: 6px;\n  background: #f3f4f6;\n  font-size: 0.9rem;\n}\n\n.verification-inline-error {\n  padding: 0.75rem;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  color: #7f1d1d;\n  background: #fef2f2;\n}\n\n@media (max-width: 600px) {\n  .verification-record {\n    display: grid;\n  }\n\n  .verification-record__status {\n    text-align: left;\n  }\n}\n\n[data-theme='dark'] .verification-center--card,\n[data-theme='dark'] .verification-record {\n  border-color: #3a4a40;\n  background: #1c2620;\n}\n\n[data-theme='dark'] .verification-retention-notice {\n  background: #222f28;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
